import React, { createContext, useContext, useRef, ReactNode, MutableRefObject } from 'react';

type ScrollContainerContextValue = {
  scrollContainerRef: MutableRefObject<HTMLElement | null>;
};

type ScrollContainerProviderProps = {
  children: ReactNode;
};

const ScrollContainerContext = createContext<ScrollContainerContextValue | undefined>(undefined);

export const ScrollContainerProvider: React.FC<ScrollContainerProviderProps> = ({ children }) => {
  const scrollContainerRef = useRef<HTMLElement | null>(null);

  return <ScrollContainerContext.Provider value={{ scrollContainerRef }}>{children}</ScrollContainerContext.Provider>;
};

export const useScrollContainer = (): ScrollContainerContextValue => {
  const context = useContext(ScrollContainerContext);

  if (!context) {
    throw new Error('useScrollContainer must be used within a ScrollContainerProvider');
  }

  return context;
};
